import type { ResultsApi } from "@/v2/api/metadata/results";
import type { SportsApi } from "@/v2/api/metadata/sports";
import type { ContentTab, DialogTabSaveContext } from "@/v2/framework/dialog/types";
import { sportsResultsSaveRef } from "../../results/save-ref";

async function save(_ctx: DialogTabSaveContext): Promise<void> {
  if (!sportsResultsSaveRef.value) return;
  await sportsResultsSaveRef.value();
}

export function createResultsMappingTab(options: {
  sportsApi: SportsApi;
  resultsApi: ResultsApi;
}): ContentTab {
  const { sportsApi, resultsApi } = options;

  return {
    id: "results-mapping",
    label: "Results mapping",
    save,
    children: [
      {
        type: "component",
        component: () => import("../../results/SportResultsMappingFields.vue"),
        props: { mode: "edit", sportsApi, resultsApi },
      },
    ],
  };
}
